import React from 'react';
import Modal from '../../Utilities/DraggableModal';
import CollectorDropdown from '../CollectorDropdown';

const AssignClaimPopup = ({
    show,
    setShow,
    collector,
    debtorID,
    collectorOptions,
}) => {

    return (
        <div>
            <Modal show={show} onHide={setShow}>
                <Modal.Header closeButton>
                    <Modal.Title>Assign Claim</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CollectorDropdown
                        collector={collector}
                        collectorOptions={collectorOptions}
                        readOnly={false}
                        debtorID={debtorID}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AssignClaimPopup;